const HARNESS_PARAM = 'playcanvasHarness'
const DUMMY_AAPL_PARAM = 'dummyAapl'
const MOBILE_IFRAME_DEMO_PARAM = 'mobileIframeDemo'

/**
 * The harness route can only activate in a non-production build, regardless
 * of the query parameter. This guards against the harness param leaking into
 * a deployed production build's routing.
 */
export function isHarnessEnabled(search: string = window.location.search): boolean {
  if (process.env.NODE_ENV === 'production') {
    return false
  }

  return new URLSearchParams(search).get(HARNESS_PARAM) === 'true'
}

/** Development-only iframe target used by the harness for offline touch testing. */
export function isDummyAaplEnabled(search: string = window.location.search): boolean {
  if (process.env.NODE_ENV === 'production') {
    return false
  }

  return new URLSearchParams(search).get(DUMMY_AAPL_PARAM) === 'true'
}

/**
 * Development-only phone-facing demo that embeds the dummy AAPL chart in a real
 * iframe. Mutually exclusive with {@link isDummyAaplEnabled}: the demo host page
 * carries only `mobileIframeDemo=true` and its iframe target carries only
 * `dummyAapl=true`, so the embedded document can never recurse into another host.
 */
export function isMobileIframeDemoEnabled(search: string = window.location.search): boolean {
  if (process.env.NODE_ENV === 'production') {
    return false
  }

  return new URLSearchParams(search).get(MOBILE_IFRAME_DEMO_PARAM) === 'true'
}
